<ui-input-wrapper
  [label]="base.label"
  [labelTemplate]="base.labelTemplate"
  [addAsteriskToFakeRequiredLabel]="base.addAsteriskToFakeRequiredLabel()"
  [help]="base.help"
  [hint]="base.hint"
  [errors]="control.errors"
  [submitted]="submitted"
  [control]="control"
  [maxLength]="rich.maxLength()"
  [valueLength]="characterCount"
  [randomInputId]="randomInputId">
  <p-editor
    class="[word-break:break-all]"
    [style]="{ height: rich.height() }"
    [formControl]="$any(control)"
    [formats]="formats"
    #nativeInputElement
    [readonly]="base.readonly()"
    [attr.placeholder]="base.placeholder ?? base.label"
    [attr.name]="base.name()">
    <ng-template #header>
      <span class="ql-formats">
        <select class="ql-size">
          <option value="small">Malé</option>
          <option selected>Normální</option>
          <option value="large">Větší</option>
          <option value="huge">Velké</option>
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Bold"></button>
        <button class="ql-italic" aria-label="Italic"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
      </span>
    </ng-template>
  </p-editor>
</ui-input-wrapper>
